import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardSharedModule } from '../shared/card-shared.module';
import { DynamicRenderSharedModule } from '../../shared/shared.module';
import { CardResolverModule } from '../resolver/card-resolver.module';
import { StandardCardComponent } from './standard-card/standard-card.component';

const components = [StandardCardComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, CardSharedModule, CardResolverModule, DynamicRenderSharedModule]
})
export class CoreCustomCardsModule {}
